import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import logoUAE from "../assets/Nice-Logo-UAE.png";

const UAEPaySlipComponent = ({ result, response, componentRef }) => {
  const [itSectionTypeGetData, setItSectionTypeGetData] = useState([]);
  const [paySlipData, setPaySlipData] = useState([]);
  const [slipLogo, setSlipLogo] = useState("");
  const [empGetDetails, setGetEmpDetails] = useState([]);
  const [payRollComponent, setPayRollComponent] = useState([]);
  const [incomeCalculationData, setIncomeCalulationData] = useState([]);
  const [itDetailsData, setItDetailsData] = useState([]);
  const [itTaxInfo, setItTaxInfo] = useState([]);
  const [getApiMessageForTaxType, setGetApiMessageForTaxType] = useState("");
  const [showMoreStatus, setShowMoreStatus] = useState(false);

  useEffect(() => {
    setSlipLogo(response?.data?.logo || []);
    setItDetailsData(result?.itDetails || []);
    setGetApiMessageForTaxType(response?.data?.message || "");
    setItTaxInfo(result?.taxinfo?.[0] || []);
    setIncomeCalulationData(result?.regimePaySlipComponents || []);
    setPaySlipData(result); // ✅ Corrected
    setGetEmpDetails(response?.data?.employeeDetails?.[0] || []);
    setPayRollComponent(result?.payslipComponents || []);
    const itSectionType = result?.itExceptionDetails?.reduce((acc, item) => {
      if (!acc[item.ITSectionType]) {
        acc[item.ITSectionType] = [];
      }
      acc[item.ITSectionType].push(item);
      return acc;
    }, {});

    setItSectionTypeGetData(result?.itExceptionDetails || []);
  }, [result, response]);

  const formatNumber = (num) => {
    return num
      ? new Intl.NumberFormat("en-IN", {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        }).format(Math.abs(num))
      : "";
  };

  const earnings = payRollComponent?.filter(
    (ele) =>
      [239, 244, 1025, 1183, 619].includes(ele.PayrollType_054) &&
      (ele.Amount !== 0 || ele.GrossAmount !== 0)
  );

  const deductions = payRollComponent?.filter(
    (ele) =>
      [237, 238, 243, 1028, 1166, 1274].includes(ele.PayrollType_054) &&
      (ele.Amount !== 0 || ele.GrossAmount !== 0)
  );

  const net = payRollComponent?.find((ele) => ele.PayrollType_054 === 1027);

  const totalEarnings = earnings?.reduce(
    (acc, curr) => acc + (Number(curr.Amount) || 0),
    0
  );
  const totalDeductions = deductions?.reduce(
    (acc, curr) => acc + (Number(curr.Amount) || 0),
    0
  );

  const attendanceDetails = [
    ["Standard Days", Math.floor(empGetDetails?.TotalWorkingDays || 0)],
    [
      "Days Worked",
      Math.floor(empGetDetails?.PresentDays || 0) -
        Math.floor(empGetDetails?.LeaveTaken || 0),
    ],
    ["Loss of Pay Days", Math.floor(empGetDetails?.AbsentDays || 0)],
  ];
  let totalCumulative = 0;
  let totalProjected = 0;
  let totalExempted = 0;
  let totalAnnual = 0;

  const formatIndianNumber = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      maximumFractionDigits: 3,
      minimumFractionDigits: 3,
    }).format(amount);
  };
  const totGrossAfterSec10 =
    itDetailsData.find((ele) => ele.ITSectionTypes === 1206) || {};
  const IncomeChargeable =
    itDetailsData.find((ele) => ele.ITSectionTypes === 1207) || {};
  const totGrossIncome = itDetailsData.filter(
    (ele) => ele.ITSectionTypes === 1208 || ele.ITSectionTypes === 1209
  );
  const TaxableIncome = itDetailsData.filter(
    (ele) => ele.ITSectionTypes === 1210 || ele.ITSectionTypes === 1211
  );

  function numberToWords(num) {
    if (num === 0) return "Zero";

    const belowTwenty = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    const thousands = ["", "Thousand", "Million", "Billion"];

    function helper(n) {
      if (n === 0) return "";
      else if (n < 20) return belowTwenty[n] + " ";
      else if (n < 100) return tens[Math.floor(n / 10)] + " " + helper(n % 10);
      else
        return belowTwenty[Math.floor(n / 100)] + " Hundred " + helper(n % 100);
    }

    let word = "";
    let i = 0;

    while (num > 0) {
      if (num % 1000 !== 0) {
        word = helper(num % 1000) + thousands[i] + " " + word;
      }
      num = Math.floor(num / 1000);
      i++;
    }

    return word.trim();
  }

  return (
    <div>
      <div
        className="row mt-3"
        ref={componentRef}
        id="printSection"
        style={{ padding: "30px" }}
      >
        <div className="col-12">
          <div
            className="card"
            style={{ backgroundColor: "#8A6344", padding: "35px" }}
          >
            <div className="bg-white h-auto" style={{ padding: "20px" }}>
              <div
                style={{ width: "100%", display: "flex" }}
                id="slipLogoHeader"
              >
                {/* Logo Section*/}
                <div
                  style={{
                    width: "39%",
                    padding: "0px",
                    display: "flex",
                    alignItems: "flex-start",
                  }}
                >
                  <img
                    src={logoUAE || ""}
                    alt="logo"
                    style={{
                      height: "60px",
                      width: "100px",
                      maxWidth: "100%",
                      marginTop: "10px",
                    }}
                    className="img-fluid"
                  />
                </div>

                {/* Content Section */}
                <div
                  style={{
                    width: "57%",
                    textAlign: "left",
                    padding: "0px 0px 0px 10px",
                  }}
                  id="slipHeader"
                >
                  <h6 className="m-0">
                    <b>Nice Software Solutions (FZE)</b>
                  </h6>
                  <p style={{ fontWeight: "normal", marginBottom: "10px" }}>
                    SAIF Plus R6-27B, PO Box 124832, Sharjah UAE
                  </p>
                  <h5
                    style={{ fontSize: "13px", padding: "0px", margin: "0px" }}
                  >
                    <b>
                      Pay slip for the month of{" "}
                      {empGetDetails?.MonthName || "N/A"}
                    </b>
                  </h5>
                </div>
              </div>
              <hr
                style={{
                  width: "60%",
                  height: "1px",
                  backgroundColor: "black",
                  border: "none",
                  marginLeft: "auto",
                  marginRight: "0",
                  marginTop: "-1px",
                  padding: "0px",
                }}
                id="customHrLine"
              />
              <table
                id="payslipTable"
                style={{ width: "100%", borderCollapse: "collapse" }}
              >
                <tbody>
                  {/* Employee Details Section */}
                  <tr>
                    <th
                      style={{
                        width: "40%",
                        verticalAlign: "top",
                        padding: "10px",
                      }}
                      id="payslipTableEmpHeader"
                    >
                      <table id="payslipTable" style={{ width: "100%" }}>
                        <tbody>
                          <tr style={{ lineHeight: "0.8" }}>
                            <td
                              style={{
                                width: "30%",
                                fontSize: "12px",
                                fontWeight: "normal",
                              }}
                            >
                              {" "}
                              Employee No{" "}
                            </td>
                            <td
                              style={{
                                width: "5%",
                                fontSize: "12px",
                              }}
                            >
                              :
                            </td>
                            <td
                              style={{
                                width: "65%",
                                fontSize: "12px",
                                fontWeight: "normal",
                                textAlign: "left",
                              }}
                            >
                              {empGetDetails?.EmployeeCode || "N/A"}
                            </td>
                          </tr>
                          {empGetDetails?.UAN && empGetDetails?.UAN !== "0" ? (
                            <tr style={{ lineHeight: "0.8" }}>
                              <td
                                style={{
                                  width: "30%",
                                  fontSize: "12px",
                                  fontWeight: "normal",
                                }}
                              >
                                PF UAN
                              </td>
                              <td>:</td>
                              <td
                                style={{
                                  width: "65%",
                                  fontSize: "12px",
                                  fontWeight: "normal",
                                  textAlign: "left",
                                }}
                              >
                                {empGetDetails.UAN}
                              </td>
                            </tr>
                          ) : null}

                          {/* <tr style={{ lineHeight: "0.8" }}>
                            <td
                              style={{ fontSize: "12px", fontWeight: "normal" }}
                            >
                              PAN
                            </td>
                            <td>:</td>
                            <td
                              style={{ fontSize: "12px", fontWeight: "normal" }}
                            >
                              {empGetDetails?.PAN || "N/A"}
                            </td>
                          </tr>
                          <tr style={{ lineHeight: "0.8" }}>
                            <td
                              style={{ fontSize: "12px", fontWeight: "normal" }}
                            >
                              EPF No.
                            </td>
                            <td>:</td>
                            <td
                              style={{ fontSize: "12px", fontWeight: "normal" }}
                            >
                              {empGetDetails?.PFNo || "N/A"}
                            </td>
                          </tr>
                          <tr style={{ lineHeight: "0.8" }}>
                            <td
                              style={{ fontSize: "12px", fontWeight: "normal" }}
                            >
                              PF UAN
                            </td>
                            <td>:</td>
                            <td
                              style={{ fontSize: "12px", fontWeight: "normal" }}
                            >
                              {empGetDetails?.UAN || "N/A"}
                            </td>
                          </tr>
                          <tr style={{ lineHeight: "0.8" }}>
                            <td
                              style={{ fontSize: "12px", fontWeight: "normal" }}
                            >
                              Location
                            </td>
                            <td>:</td>
                            <td
                              style={{ fontSize: "12px", fontWeight: "normal" }}
                            >
                              {empGetDetails?.BranchLocation || "N/A"}
                            </td>
                          </tr> */}
                        </tbody>
                      </table>
                    </th>

                    {/* Employee Personal Details Section */}
                    <th
                      style={{
                        width: "60%",
                        verticalAlign: "top",
                        padding: "10px",
                      }}
                    >
                      <table
                        id="payslipTable"
                        style={{
                          width: "100%",
                          tableLayout: "fixed",
                          borderCollapse: "collapse",
                        }}
                      >
                        <tbody>
                          <tr style={{ lineHeight: "0.8" }}>
                            <td
                              style={{
                                width: "30%",
                                fontSize: "12px",
                                fontWeight: "normal",
                              }}
                            >
                              Name
                            </td>
                            <td style={{ width: "5%", fontSize: "12px" }}>:</td>
                            <td
                              style={{
                                width: "65%",
                                fontSize: "12px",
                                fontWeight: "normal",
                              }}
                            >
                              {empGetDetails?.EmployeeName || "N/A"}
                            </td>
                          </tr>
                          <tr style={{ lineHeight: "0.8" }}>
                            <td
                              style={{
                                width: "30%",
                                fontSize: "12px",
                                fontWeight: "normal",
                              }}
                            >
                              Designation
                            </td>
                            <td style={{ width: "5%", fontSize: "12px" }}>:</td>
                            <td
                              style={{
                                width: "65%",
                                fontSize: "12px",
                                fontWeight: "normal",
                              }}
                            >
                              {empGetDetails?.Designation || "N/A"}
                            </td>
                          </tr>
                          <tr style={{ lineHeight: "0.8" }}>
                            <td
                              style={{
                                width: "30%",
                                fontSize: "12px",
                                fontWeight: "normal",
                              }}
                            >
                              Gender
                            </td>
                            <td style={{ width: "5%", fontSize: "12px" }}>:</td>
                            <td
                              style={{
                                width: "65%",
                                fontSize: "12px",
                                fontWeight: "normal",
                              }}
                            >
                              {empGetDetails?.Gender || "N/A"}
                            </td>
                          </tr>
                          <tr style={{ lineHeight: "0.8" }}>
                            <td
                              style={{
                                width: "30%",
                                fontSize: "12px",
                                fontWeight: "normal",
                              }}
                            >
                              Date Of Joining
                            </td>
                            <td style={{ width: "5%", fontSize: "12px" }}>:</td>
                            <td
                              style={{
                                width: "65%",
                                fontSize: "12px",
                                fontWeight: "normal",
                              }}
                            >
                              {empGetDetails?.JoiningDate || "N/A"}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </th>
                  </tr>
                </tbody>
              </table>
              {/* <div
                className=""
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div className=" mt-3">
                  <div className="row">
                    <div className="col-12 text-start">
                      <img
                        src={slipLogo}
                        alt="logo"
                        style={{ height: "70px" }}
                        className="img-fluid"
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-12">
                      <div className="d-flex flex-column gap-2">
                        <p>
                          <strong>Employee No:</strong>{" "}
                          <span className="ms-2">
                            {empGetDetails?.EmployeeCode}
                          </span>
                        </p>
                        <p>
                          <strong>PAN No:</strong>{" "}
                          <span className="ms-2">{empGetDetails?.PAN}</span>
                        </p>
                        <p>
                          <strong>EPF No:</strong>{" "}
                          <span className="ms-2">{empGetDetails?.PFNo}</span>
                        </p>
                        <p>
                          <strong>PF UAN:</strong>{" "}
                          <span className="ms-2">{empGetDetails?.UAN}</span>
                        </p>
                        <p>
                          <strong>Location:</strong>{" "}
                          <span className="ms-2">
                            {empGetDetails?.BranchLocation}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-3">
                  <div className="row ">
                    <h3>{empGetDetails?.CompanyName}</h3>
                    <p>{empGetDetails?.CompanyAddress}</p>
                    <p> Pay slip for the month of April 2024 </p>
                  </div>
                  <hr></hr>
                  <div className="row">
                    <div className="row mt-2">
                      <p>
                        <strong>Name:</strong>{" "}
                        <span className="ms-2">
                          {empGetDetails?.EmployeeName}
                        </span>
                      </p>
                      <p>
                        <strong>Designation:</strong>{" "}
                        <span className="ms-2">
                          {empGetDetails?.Designation}
                        </span>
                      </p>
                      <p>
                        <strong>Gender:</strong>{" "}
                        <span className="ms-2">{empGetDetails?.Gender}</span>
                      </p>
                      <p>
                        <strong>Date Of Joining:</strong>{" "}
                        <span className="ms-2">
                          {empGetDetails?.JoiningDate}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="row">
                <h6
                  style={{
                    marginBottom: "5px",
                    paddingLeft: "0px",
                    color: "#003366",
                    fontSize: "11px",
                  }}
                >
                  <strong>Payroll Details</strong>
                </h6>
                <Table
                  striped
                  bordered
                  style={{ width: "100%", marginBottom: "20px" }}
                >
                  <thead className="text-center">
                    <tr>
                      <th
                        style={{
                          width: "20%",
                          padding: "0px",
                          fontSize: "12px",
                          backgroundColor: "#C9D5E2",
                        }}
                      >
                        Earnings
                      </th>
                      <th
                        style={{
                          width: "10%",
                          padding: "0px",
                          fontSize: "12px",
                          backgroundColor: "#C9D5E2",
                        }}
                      >
                        Gross Amount
                      </th>
                      <th
                        style={{
                          width: "10%",
                          padding: "0px",
                          fontSize: "12px",
                          backgroundColor: "#C9D5E2",
                        }}
                      >
                        Amount
                      </th>
                      <th
                        style={{
                          width: "20%",
                          padding: "0px",
                          fontSize: "12px",
                          backgroundColor: "#C9D5E2",
                        }}
                      >
                        Deductions
                      </th>
                      <th
                        style={{
                          width: "10%",
                          padding: "0px",
                          fontSize: "12px",
                          backgroundColor: "#C9D5E2",
                        }}
                      >
                        Amount
                      </th>
                      <th
                        style={{
                          width: "15%",
                          padding: "0px",
                          fontSize: "12px",
                          backgroundColor: "#C9D5E2",
                        }}
                      ></th>
                      <th
                        style={{
                          width: "15%",
                          padding: "0px",
                          fontSize: "12px",
                          backgroundColor: "#C9D5E2",
                        }}
                      ></th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.from({
                      length: Math.max(
                        earnings.length,
                        deductions.length,
                        attendanceDetails.length
                      ),
                    }).map((_, i) => (
                      <tr key={i}>
                        <td
                          className="tdBorder"
                          style={{
                            padding: "0px 2px",
                            fontSize: "12px",
                            fontWeight: "normal",
                          }}
                        >
                          {earnings[i]?.SalarySlipHead || ""}
                        </td>
                        <td
                          className="text-end"
                          style={{
                            padding: "0px 2px",
                            fontSize: "12px",
                            fontWeight: "normal",
                          }}
                        >
                          {formatNumber(earnings[i]?.GrossAmount)}
                        </td>
                        <td
                          className="text-end"
                          style={{
                            padding: "0px 2px",
                            fontSize: "12px",
                            fontWeight: "normal",
                          }}
                        >
                          {formatNumber(earnings[i]?.Amount)}
                        </td>
                        <td
                          style={{
                            padding: "0px 2px",
                            fontSize: "12px",
                            fontWeight: "normal",
                          }}
                        >
                          {deductions[i]?.SalarySlipHead || ""}
                        </td>
                        <td
                          className="text-end"
                          style={{
                            padding: "0px 2px",
                            fontSize: "12px",
                            fontWeight: "normal",
                          }}
                        >
                          {formatNumber(deductions[i]?.Amount)}
                        </td>
                        <td
                          style={{
                            padding: "0px 2px",
                            fontSize: "12px",
                            fontWeight: "normal",
                          }}
                        >
                          {attendanceDetails[i]?.[0] || ""}
                        </td>
                        <td
                          className="text-end"
                          style={{
                            padding: "0px 2px",
                            fontSize: "12px",
                            fontWeight: "normal",
                          }}
                        >
                          {attendanceDetails[i]?.[1] || ""}
                        </td>
                      </tr>
                    ))}
                    <tr className="total">
                      <td style={{ padding: "0px 2px", fontSize: "12px" }}>
                        Total Earnings
                      </td>
                      <td
                        className="text-end"
                        colSpan="2"
                        style={{ padding: "0px 2px", fontSize: "12px" }}
                      >
                        {formatNumber(totalEarnings)}
                      </td>
                      <td style={{ padding: "0px 2px", fontSize: "12px" }}>
                        Total Deductions
                      </td>
                      <td
                        className="text-end"
                        style={{ padding: "0px 2px", fontSize: "12px" }}
                      >
                        {formatNumber(totalDeductions)}
                      </td>
                      <td className="tdBorder"></td>
                      <td className="tdBorder"></td>
                    </tr>
                    <tr className="total">
                      <td className="tdBorder" colSpan="3"></td>
                      <td style={{ padding: "0px 2px", fontSize: "12px" }}>
                        {`${net?.SalarySlipHead} (AED)` || ""}
                      </td>
                      <td
                        className="text-end"
                        style={{ padding: "0px 2px", fontSize: "12px" }}
                      >
                        {formatNumber(net?.Amount)}
                      </td>
                      <td className="tdBorder" colSpan="2"></td>
                    </tr>
                  </tbody>
                </Table>
                {/* <div
                  id="payslipTable"
                  style={{ fontSize:"12px", fontWeight:"normal", marginTop:"-15px" }}
                >
                  In words: <strong>{` In words : Rs.${numberToWords(
                    net?.Amount
                  )} `}</strong>, will
                  be credited in your bank account{" "}
                  50100767399919.
                </div> */}
              </div>
              {/* <div className="row">
                <span>
                  {` In words : Rs.${numberToWords(
                    net?.Amount
                  )} , will be credited in your bank account
                  912010009099068.`}
                </span>
              </div> */}
              <div>
                <blockquote className="remark">
                  <strong>NOTE:</strong>
                </blockquote>

                <div
                  className="divide-bot-top"
                  style={{
                    textAlign: "center",
                    fontSize: "11px",
                    width: "100%",
                    marginTop: "10px",
                  }}
                >
                  ** This is a computer-generated payslip and does not require a
                  signature and stamp.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UAEPaySlipComponent;
